import { Action, ApplyScan, HandlerCallback } from './interface'
import { ScanCache } from '../ScanCache'

export interface HandlerInput {
  cache: ScanCache
}

export class Handler {
  callbacks: HandlerCallback[]
  cache: ScanCache

  constructor(props: HandlerInput) {
    this.callbacks = []
    this.cache = props.cache
  }

  registerCb = (cb: HandlerCallback) => {
    this.callbacks.push(cb)
  }

  removeCb = (cb: HandlerCallback) => {
    const index = this.callbacks.indexOf(cb)
    if (index > -1) {
      this.callbacks.splice(index, 1)
    }
  }

  notify = (data: any) => {
    this.callbacks.map((cb) => cb(data))
  }

  getContext: () => object = () => {
    return {}
  }

  apply: (data: ApplyScan) => [Action, any | undefined] = () => {
    return [Action.None, undefined]
  }

  applyAudit: (context?: any) => Handler = () => this
  applyFound: (context?: any) => Handler = () => this
  applyPrint: (context?: any) => Handler = () => this
  applyPrintCaseLabels: (context?: any) => Handler = () => this
  applySetSSCC: (context?: any) => Handler = () => this
}
